import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

import { serialize } from 'object-to-formdata';
import { MailAutoAcknowledge } from '../interfaces/mail';
import { MailTemplate } from '../interfaces/mail-template';

@Injectable({
  providedIn: 'root',
})
export class MailTemplatesAdapter {
  private http = inject(HttpClient);

  getMailTemplates(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/company/mail-templates`);
  }

  createMailTemplate(mailTemplate: MailTemplate): Observable<any> {
    return this.http.post(
      `${environment.apiBaseUrl}/company/mail-templates`,
      serialize(mailTemplate, {
        nullsAsUndefineds: true,
      })
    );
  }

  editMailTemplate(mailTemplateID: number, mailTemplate: MailTemplate): Observable<any> {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/mail-templates/${mailTemplateID}`,
      serialize(mailTemplate, {
        nullsAsUndefineds: true,
      })
    );
  }

  deleteMailTemplate(mailTemplate: MailTemplate): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}/company/mail-templates/${mailTemplate.id}`);
  }

  getAcknowledge(): Observable<MailAutoAcknowledge> {
    return this.http.get<MailAutoAcknowledge>(`${environment.apiBaseUrl}/company/mail-templates/acknowledge`);
  }

  setAcknowledge(payload: MailAutoAcknowledge): Observable<any> {
    return this.http.patch(`${environment.apiBaseUrl}/company/mail-templates/acknowledge`, payload);
  }
}
